import React from 'react';
import {connect} from "react-redux";
import './mycreatives.css';
import Pagination from '../Pagination/Pagination';
import queryString from "query-string";
import {get} from "../../utils/api";
import {fetchMyCreatives} from "../../actions/unitActions";
import SearchRow from "../Search/SearchRow";

class MyCreatives extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            user: {},
        }

    }
    componentDidMount() {
        this.getUser();
    };
    componentDidUpdate(prevProps, prevState, snapshot) {
        let query = this.props.location.search;
        let queryParams = queryString.parse(query);
        let nextPage = typeof queryParams.page !== 'undefined' && !isNaN(queryParams.page) ? parseInt(queryParams.page, 10) : 1;
        let prevPage = parseInt(prevProps.pagination.current_page, 10);
        if (prevPage !== nextPage && !this.props.loading) {
            this.props.dispatch(fetchMyCreatives(this.state.user.id, nextPage));
        }
    }

    getUser() {
        return get('/user')
            .then((res) => {
                this.setState({
                    user: res.user
                })
            }).then(() => {
                let user = this.state.user;
                this.props.dispatch(fetchMyCreatives(user.id, 1))
            });
    }

    render() {
        const {pagination, loading, units} = this.props;
        return (
            <div className="campaign-info my-creative-table">
                <div className="my-creative-header">
                    <h1>My Creatives</h1>
                    <Pagination
                        totalRecords={pagination.total_records}
                        pageLimit={pagination.page_limit}
                        currentPage={pagination.current_page}
                        totalPages={pagination.total_pages}
                        loading={loading}
                        route="/manage/my_creatives"
                    />
                </div>
                <div className="search-table-wrapper">
                    <table className="table table-sort brand-table">
                        <thead>
                        <tr>
                            <th className="creative-tr">Creative</th>
                            <th>Brand</th>
                            <th>Campaign Name</th>
                            <th>Vertical</th>
                            <th>Type</th>
                            <th>Functionality</th>
                            <th>Designer</th>
                            <th>Date</th>
                            <th>Links</th>
                        </tr>
                        </thead>
                        <tbody>
                        {units.map((row, key) => (
                            <SearchRow key={key} row={row} />
                        ))}
                        </tbody>
                    </table>
                </div>
                <div className="my-creative-footer">
                    <Pagination
                        totalRecords={pagination.total_records}
                        pageLimit={pagination.page_limit}
                        currentPage={pagination.current_page}
                        totalPages={pagination.total_pages}
                        loading={loading}
                        route="/manage/my_creatives"
                    />
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => ({
        pagination: state.unit.pagination,
        loading: state.unit.loading,
        units: state.unit.my_creatives,
})
export default connect(mapStateToProps)(MyCreatives);
